export default {
    help: 'Help section'
}
